<template>
  <div class="wrap">
    <Navbar :title="detail?.lottery_title || ''" />
    <div class="wrap_cont">
      <div class="wrap_cont_top">
        <div class="_title">{{ detail.title }}</div>
        <div class="wrap_cont_top_grid">
          <div class="grid_item">
            <div class="label">{{ $t('连胜连败') }}</div>
            <div class="value" v-if="detail.hits_num">
              {{ $t('连中', { __: detail.hits_num }) }}
            </div>
            <div class="value" v-if="detail.losses_num">
              {{ $t('连中', { __: detail.losses_num }) }}
            </div>
          </div>
          <div class="grid_item">
            <div class="label">{{ $t('投注金额') }}</div>
            <div class="value">{{ $money(detail.cycle_betmoney || '0.00') }}</div>
          </div>
          <div class="grid_item">
            <div class="label">{{ $t('奖金金额') }}</div>
            <div class="value">{{ $money(detail.cycle_winmoney || '0.00') }}</div>
          </div>
          <div class="grid_item">
            <div class="label">{{ $t('代理佣金') }}</div>
            <div class="value">{{ $money(detail.cycle_rebate || '0.00') }}</div>
          </div>
          <div class="grid_item">
            <div class="label">{{ $t('累计利润') }}</div>
            <div class="value" :style="Number(detail?.cycle_winmoney) -
              Number(detail?.cycle_betmoney) < 0 ? { color: '#e84f62' } : { color: '#31e2a5' }">{{
                $money((Number(detail?.cycle_winmoney) -
                  Number(detail?.cycle_betmoney)).toFixed(2)) }}</div>
          </div>
        </div>
      </div>
      <div class="wrap_list" v-for="item, index in historyList" :key="index">
        <div class="list_top">
          <div class="list_top_left">
            <div class="title">{{ detail.title }}</div>
            <span>{{ $t('计划内容') }}:&nbsp;</span>
            <div class="result">{{ item?.plan_content }}</div>
          </div>
          <div class="plan_top_right" v-if="item.hits_num">{{ $t('连中', { __: item.hits_num }) }}</div>
          <div class="plan_top_right" v-else-if="item.losses_num">{{ $t('连跌', { __: item.losses_num }) }}</div>
        </div>
        <div class="list_table">
          <div class="table_tr">{{ $t('期数') }}</div>
          <div class="table_tr">{{ $t('开奖结果') }}</div>
          <div class="table_tr">{{ $t('AI投注') }}</div>
          <div class="table_tr">{{ $t('奖金') }}</div>
          <div class="table_tr">{{ $t('盈亏') }}</div>
          <div class="table_tr">{{ $t('本期结算') }}</div>
          <div class="table_th">{{ getDraw(item?.issues[0]?.expect) }}</div>
          <div class="table_th">{{ item?.issues[0]?.open_result || '--' }}</div>
          <div class="table_th" :class="[item?.issues[0]?.ai_bet && 'is_red']">{{ item?.issues[0]?.ai_bet || '--' }}
          </div>
          <div class="table_th" :class="[item?.issues[0]?.prize > 0 && 'is_green']">{{ getNum(item?.issues[0]?.prize) }}
          </div>
          <div class="table_th" :class="item?.issues[0]?.profit > 0 ? 'is_green' : 'is_red'">{{
            getNum(item?.issues[0]?.profit) }}</div>
          <div class="table_th table__settlement" :class="item?.settlement_amount > 0 ? 'is_green' : 'is_red'">{{ typeof
            getNum(item?.settlement_amount) == 'string' ? getNum(item?.settlement_amount) :
            $money(item?.settlement_amount) }}</div>
          <div class="table_th">{{ getDraw(item?.issues[1]?.expect) }}</div>
          <div class="table_th">{{ item?.issues[1]?.open_result || '--' }}</div>
          <div class="table_th" :class="[item?.issues[1]?.ai_bet && 'is_red']">{{ item?.issues[1]?.ai_bet || '--' }}
          </div>
          <div class="table_th" :class="[item?.issues[1]?.prize > 0 && 'is_green']">{{ getNum(item?.issues[1]?.prize) }}
          </div>
          <div class="table_th" :class="item?.issues[1]?.profit > 0 ? 'is_green' : 'is_red'">{{
            getNum(item?.issues[1]?.profit) }}</div>
          <div class="table_th">{{ getDraw(item?.issues[2]?.expect) }}</div>
          <div class="table_th">{{ item?.issues[2]?.open_result || '--' }}</div>
          <div class="table_th" :class="[item?.issues[2]?.ai_bet && 'is_red']">{{ item?.issues[2]?.ai_bet || '--' }}
          </div>
          <div class="table_th" :class="[item?.issues[2]?.prize > 0 && 'is_green']">{{ getNum(item?.issues[2]?.prize) }}
          </div>
          <div class="table_th" :class="item?.issues[2]?.profit > 0 ? 'is_green' : 'is_red'">{{
            getNum(item?.issues[2]?.profit) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AI_PLAN } from "@/api";
import Navbar from "@/components/JNav";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      plan_id: this.$route.query.id,
      detail: {},
      historyList: []
    }
  },
  created() {
    this.getOrder();
  },
  methods: {
    getDraw(_expect) {
      if (!_expect) return '';
      return _expect.slice(8)
    },
    getNum(_num) {
      if (_num == null) return '--';
      return _num - 0
    },
    async getOrder() {
      try {
        const res = await AI_PLAN({
          id: this.plan_id,
        });
        this.detail = res.data
        this.historyList = res.data?.history?.rounds || []
      } catch (error) {

      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: radial-gradient(circle at top right, rgba(49, 226, 165, .16), transparent 26%), radial-gradient(circle at left 25%, rgba(91, 140, 255, .12), transparent 22%), linear-gradient(180deg, #fbfcff, #f1f5fb);

  :deep(.van-nav-bar) {
    background: linear-gradient(90deg, #4c35c7, #6040d1) !important;

    .van-icon,
    .van-nav-bar__title {
      color: var(--light) !important;
    }

    .nav_right {
      color: var(--light);
    }
  }

  .wrap_cont {
    min-height: calc(100vh - 46px - 28px);
    padding: 10px 10px 18px;

    .wrap_cont_top {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;

      ._title {
        padding: 10px 12px;
        display: flex;
        align-items: center;
        gap: 12px;
        background: linear-gradient(115deg, #ffffff40, #fff0 36%), linear-gradient(100deg, #315f9e, #24518d);
        color: #fff;
        font-size: 16px;
        font-weight: 800;
      }

      .wrap_cont_top_grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        padding: 12px;
        align-items: stretch;

        .grid_item {
          padding: 0 6px 10px;
          font-weight: 600;
          border-right: 1px solid #e7eaf0;

          .label {
            font-size: 13px;
            color: #7a8597;
          }

          .value {
            font-size: 14px;
            color: #3f4248;
            margin-top: 5px;
          }
        }

        .grid_item:nth-child(3n),
        .grid_item:last-child {
          border-right: none;
        }
      }
    }

    .wrap_list {
      margin-top: 18px;

      .list_top {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        font-size: 15px;
        font-weight: 600;

        .list_top_left {
          display: flex;
          align-items: baseline;

          .title {
            color: #e84f63;
            font-size: 16px;
          }

          span {
            color: #7a8597;
            margin-left: 6px;
          }

          .result {
            color: #222;
          }
        }


        .plan_top_right {
          color: #ff5f59;
          font-size: 16px;
          font-weight: 600;
        }
      }

      .list_table {
        margin-top: 8px;
        display: grid;
        grid-template-columns: 1.1fr 1.6fr 1.25fr 1.1fr 1.1fr 1.45fr;
        background: #e8ebf0;
        border: 1px solid #e8ebf0;
        gap: 1px;

        .table_tr,
        .table_th {
          min-width: 0;
          min-height: 38px;
          padding: 6px 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          color: #7a8597;
          font-size: 16px;
          font-weight: 700;
          text-align: center;
          word-break: break-word;
        }

        .table__settlement {
          grid-column: 6;
          grid-row: span 3;
          flex-direction: column;
          gap: 4px;
        }

        .is_red {
          color: #e84f62;
        }

        .is_green {
          color: #31e2a5;
        }
      }
    }
  }
}
</style>